import { render, staticRenderFns } from "./GroupsOverview.vue?vue&type=template&id=1f0ac8d9&scoped=true&"
import script from "./GroupsOverview.vue?vue&type=script&lang=ts&"
export * from "./GroupsOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0ac8d9",
  null
  
)

export default component.exports